/**
 * @fileoverview Diz se o usuário logado pode encerrar conversas (botão
 * Resolver). Com a setting "ticketCloseButton" desligada (só o super admin
 * muda, em Configurações → Módulos), o atendente não encerra; admin e super
 * sempre encerram. O servidor confere a mesma regra
 * (services/TicketServices/ticketCloseAccess.ts no backend). Com a regra nova
 * de acesso ligada, vale tickets.close (que já tem essa opção como teto).
 *
 * O valor conhecido vale já no primeiro desenho e o aviso por socket tira ou
 * devolve o botão sem recarregar a página (hooks/useCompanySetting).
 */

import { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import useCompanySetting from "../useCompanySetting";
import usePermission from "../usePermission";

const useTicketCloseButton = () => {
  const { user } = useContext(AuthContext);
  const { can, enforce } = usePermission();
  const alwaysCloses = user?.profile === "admin" || !!user?.super;
  const [value, status] = useCompanySetting("ticketCloseButton", { skip: alwaysCloses || enforce });
  if (enforce) return can("tickets.close", false);
  if (alwaysCloses) return true;
  // Sem valor conhecido, o botão espera a primeira leitura: na empresa com a
  // opção desligada, ele não aparece e some. Se a leitura falhou e nada se
  // sabe, o botão aparece (o servidor confere de novo).
  if (status === "failed") return true;
  return status === "known" && value !== "disabled";
};

export default useTicketCloseButton;
